var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4318ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4 13.4a1.8 1.8 0 0 1 3.6 0v7.2a1.8 1.8 0 0 1-3.6 0zM7.2 13.2v6.517a2.4 2.4 0 0 0 1.327 2.147l.06.03a4.8 4.8 0 0 0 2.146.506h6.5a2.4 2.4 0 0 0 2.353-1.93l1.44-7.2a2.4 2.4 0 0 0-2.354-2.87H14.4V5.6A2.4 2.4 0 0 0 12 3.2a1.2 1.2 0 0 0-1.2 1.2v.8a4.8 4.8 0 0 1-.96 2.88l-1.68 2.24a4.8 4.8 0 0 0-.96 2.88z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFull);
export default __webpack_public_path__ + "static/media/like-full.7226ff8835d6a107f5ba32bc4a5a4e38.svg";
export { ForwardRef as ReactComponent };